<template>
  <div class="founders-form">
    <KycDropdown
      title="Founders Information"
      subTitle="Fill in founders information"
      :status="orgDetails.tokens?.length ? true : false"
      :edit="''"
      @active-dropdown="setDropdownStatus"
    >
      <template v-slot:content>
        <form @submit.prevent="submitFounder" class="form-content">
          <div
            v-for="(founder, index) in founders"
            :key="index"
            class="founder-card"
          >
            <div class="founder-header" v-if="founders.length > 1">
              <span class="founder-label">Founder {{ index + 1 }}</span>
              <button
                type="button"
                class="btn-remove"
                @click="removeFounder(index, founder._id)"
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2 4H14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                  <path d="M12.6667 4V13.3333C12.6667 14 12 14.6667 11.3333 14.6667H4.66667C4 14.6667 3.33333 14 3.33333 13.3333V4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M5.33333 4V2.66667C5.33333 2 6 1.33333 6.66667 1.33333H9.33333C10 1.33333 10.6667 2 10.6667 2.66667V4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                Remove
              </button>
            </div>
            <div class="form-grid">
              <div class="form-group">
                <TextInput
                  placeHolder="First name"
                  label="First name"
                  type="text"
                  fieldType="text"
                  name="fname"
                  id="fname"
                  :showLabel="true"
                  :text="founder.fname"
                  @set="setFirstName($event, index)"
                  @valid="firstNameValid($event, index)"
                />
              </div>
              <div class="form-group">
                <TextInput
                  placeHolder="Last name"
                  label="Last name"
                  type="text"
                  fieldType="text"
                  name="lname"
                  id="lname"
                  :showLabel="true"
                  :text="founder.lname"
                  @set="setLastName($event, index)"
                  @valid="lastNameValid($event, index)"
                />
              </div>
              <div class="form-group full-width">
                <TextInput
                  placeHolder="Email address"
                  label="Email"
                  type="email"
                  fieldType="email"
                  name="email"
                  id="email"
                  :showLabel="true"
                  :email="founder.email"
                  @set="setEmail($event, index)"
                  @valid="emailValid($event, index)"
                />
              </div>
            </div>
          </div>

          <button type="button" class="btn-add-founder" @click="addFounder">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 3.75V14.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              <path d="M3.75 9H14.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
            Add Another Founder
          </button>

          <div class="form-actions">
            <button type="submit" class="btn-primary" :disabled="founderLoading">
              <span v-if="founderLoading" class="btn-loader"></span>
              {{ $route.name === 'EsopDetails' ? 'Save Changes' : 'Continue' }}
            </button>
          </div>
        </form>
      </template>
    </KycDropdown>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import KycDropdown from "@/components/general/KycDropdown.vue";
import TextInput from "@/components/general/TextInput.vue";

export default {
  name: "FoundersForm",

  components: {
    KycDropdown,
    TextInput,
  },

  data() {
    return {
      founderLoading: false,
      validInput: [
        {
          firstName: false,
          lastName: false,
          email: false,
        },
      ],
      founders: [
        {
          fname: "",
          lname: "",
          email: "",
        },
      ],
    };
  },

  computed: {
    ...mapState({
      orgDetails: (state) => state.organisationModule.organisationDetails,
      assetDetails: (state) => state.assetModule.assetDetails,
    }),
  },

  mounted() {
    this.setFounder();
  },

  methods: {
    ...mapActions("assetModule", [
      "getAsset",
      "updateAsset",
      "deleteFounder",
    ]),
    ...mapActions(["showToast"]),

    setDropdownStatus(title) {
      this.$emit("dropdown-title", title);
    },

    async submitFounder() {
      for (let i = 0; i < this.validInput.length; i++) {
        if (
          !this.validInput[i].firstName ||
          !this.validInput[i].lastName ||
          !this.validInput[i].email
        ) {
          return this.showToast({
            description: "Please fill all input field correctly",
            display: true,
            type: "error",
          });
        }
      }
      this.founderLoading = true;
      // Only send allowed founder fields to avoid API validation errors
      const cleanedFounders = this.founders.map((founder) => ({
        ...(founder._id && { _id: founder._id }),
        fname: founder.fname,
        lname: founder.lname,
        email: founder.email,
      }));
      const payload = {
        about: this.assetDetails.about,
        name: this.assetDetails.name,
        type: this.assetDetails.type,
        founders: cleanedFounders,
      };
      const response = await this.updateAsset({
        data: payload,
        id: this.$route.query.asset
          ? this.$route.query.asset
          : this.assetDetails._id,
      });
      if (response) this.$emit("dropdown-title", "Socials");
      this.founderLoading = false;
    },

    setFirstName(val, index) {
      this.founders[index].fname = val;
    },

    firstNameValid(val, index) {
      this.validInput[index].firstName = val;
    },

    setLastName(val, index) {
      this.founders[index].lname = val;
    },

    lastNameValid(val, index) {
      this.validInput[index].lastName = val;
    },

    setEmail(val, index) {
      this.founders[index].email = val;
    },

    emailValid(val, index) {
      this.validInput[index].email = val;
    },

    addFounder() {
      this.founders.push({
        fname: "",
        lname: "",
        email: "",
      });
      this.validInput.push({
        firstName: false,
        lastName: false,
        email: false,
      });
    },

    async removeFounder(index, id) {
      if (id) {
        await this.deleteFounder(id);
      }
      this.founders.splice(index, 1);
      this.validInput.splice(index, 1);
    },

    setFounder() {
      if (this.assetDetails?.founders?.length) {
        // Only extract allowed fields to avoid sending restricted fields to API
        this.founders = this.assetDetails.founders.map((founder) => ({
          _id: founder._id,
          fname: founder.fname,
          lname: founder.lname,
          email: founder.email,
        }));
        this.validInput = this.assetDetails.founders.map(() => ({
          firstName: true,
          lastName: true,
          email: true,
        }));
      }
    },
  },

  watch: {
    assetDetails(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.setFounder();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.founders-form {
  .form-content {
    padding: 8px 0;
  }

  .founder-card {
    background: #F8FAFC;
    border: 1px solid #E2E8F0;
    border-radius: 10px;
    padding: 20px;
    margin-bottom: 16px;

    &:last-of-type {
      margin-bottom: 20px;
    }
  }

  .founder-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid #E2E8F0;
  }

  .founder-label {
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #0F172A;
  }

  .btn-remove {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 12px;
    background: transparent;
    border: 1px solid #FEE2E2;
    border-radius: 6px;
    font-family: 'DM Sans', sans-serif;
    font-size: 13px;
    font-weight: 400;
    color: #EF4444;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background: #FEF2F2;
      border-color: #FECACA;
    }
  }

  .form-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }

  .form-group {
    display: flex;
    flex-direction: column;

    &.full-width {
      grid-column: 1 / -1;
    }
  }

  .btn-add-founder {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 10px 16px;
    background: transparent;
    border: 1px dashed #CBD5E1;
    border-radius: 8px;
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #4D84FF;
    cursor: pointer;
    transition: all 0.2s ease;
    margin-bottom: 24px;

    &:hover {
      background: #EEF2FF;
      border-color: #4D84FF;
    }
  }

  .form-actions {
    display: flex;
    justify-content: flex-end;
    padding-top: 16px;
    border-top: 1px solid #E2E8F0;
  }

  .btn-primary {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    height: 44px;
    padding: 0 24px;
    background: #4D84FF;
    border: none;
    border-radius: 8px;
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #FFFFFF;
    cursor: pointer;
    transition: background 0.2s ease;

    &:hover:not(:disabled) {
      background: #3A6FE8;
    }

    &:disabled {
      opacity: 0.7;
      cursor: not-allowed;
    }
  }

  .btn-loader {
    width: 16px;
    height: 16px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-top-color: #FFFFFF;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
}
</style>
